import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Öffnet die Personenakte aus einer Liste und gibt die aktuelle Adresse samt Filtern als Rückweg mit.
 * Die Akte merkt sich diese Herkunft je Person (`rememberPersonBackTarget`), auch über Reiterwechsel
 * und Neuladen hinweg. Leere Kennungen werden ignoriert. `tab` öffnet einen Reiter der Akte (`?tab=`).
 */
export function usePersonFileNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback((personId: string | null | undefined, tab?: string) => {
    const id = String(personId ?? "").trim();
    if (!id) return;
    navigate(`/persons/${encodeURIComponent(id)}${tab ? `?tab=${encodeURIComponent(tab)}` : ""}`, {
      state: { from: `${location.pathname}${location.search}` }
    });
  }, [navigate, location.pathname, location.search]);
}
